import { USER_INFO_API, UPDATE_USER_INFO_API, UPDATE_PASSWORD_API } from '@constants/api';
import _axios from '@plugins/_axios';

/**
 * 获取用户信息
 */
export function getUserInfo() {
    return _axios.post(USER_INFO_API);
}

/**
 * 修改用户资料
 * @param {Number} grade 年级
 * @param {String} real_name 真实姓名
 * @param {String} school 学校
 * @param {String} avatar 头像地址
 */
export function updateUserInfo({ grade, real_name, school, avatar }) {
    return _axios.post(UPDATE_USER_INFO_API, {
        grade,
        real_name,
        school,
        avatar
    });
}

/**
 * 修改密码(根据旧密码)
 * @param {String} old_password 旧密码
 * @param {String} new_password 新密码
 */
export function updatePassword(old_password, new_password) {
    return _axios.post(UPDATE_PASSWORD_API, {
        old_password,
        new_password
    });
}
